import { provideZoneChangeDetection } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi(), withXhr())
  ]
})
  .catch(err => console.error(err));
